import { getData, postData } from './http';

export function referFriends(friends: TR.Friend[]) {
    return postData('/api2/private/users/discounts/referfriends', {
        Friends: friends,
        DomainId: TRPCONFIG.Domain.DomainId
    });
}

export function getDiscountCodeForUser() {
    return getData<string>('website/discounts/getdiscountcodeforuser')
        .then(data => TRPCONFIG.DiscountCode = data);
}

export function validate(): Promise<void> {
    if (!TRPCONFIG.DiscountCode) {
        return Promise.resolve();
    }

    const params = new URLSearchParams();
    params.set('code', TRPCONFIG.DiscountCode);
    return getData(`website/discounts/validate?${params}`).then(data => {
        if (!data) {
            TRPCONFIG.DiscountCode = null;
        }
    });
}
